import { useEffect, useState } from "react";
import { BACKEND_URL } from "../config/api";
import "../styles/OdpadyPage.css";

export default function OdpadyPage({ authToken }) {
  const [materials, setMaterials] = useState([]);
  const [material, setMaterial] = useState("");
  const [length, setLength] = useState("");
  const [width, setWidth] = useState("");
  const [thickness, setThickness] = useState("");
  const [results, setResults] = useState(null);
  const [searchState, setSearchState] = useState({ loading: false, error: "" });

  useEffect(() => {
    async function fetchMaterials() {
      try {
        const response = await fetch(`${BACKEND_URL}/api/odpady/materials`, {
          headers: { Authorization: `Bearer ${authToken}` },
        });
        const data = await response.json();
        if (response.ok) {
          setMaterials(data);
          if (data.length) setMaterial(data[0]);
        }
      } catch (error) {
        console.log(error);
      }
    }

    fetchMaterials();
  }, [authToken]);

  async function handleSearch(event) {
    event.preventDefault();

    setSearchState({ loading: true, error: "" });
    setResults(null);

    try {
      const params = new URLSearchParams({ material, length, width });
      if (thickness.trim()) params.set("thickness", thickness.trim());

      const response = await fetch(`${BACKEND_URL}/api/odpady/search?${params}`, {
        headers: { Authorization: `Bearer ${authToken}` },
      });
      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message ?? "Błąd wyszukiwania.");
      }

      setResults(data);
      setSearchState({ loading: false, error: "" });
    } catch (error) {
      setSearchState({ loading: false, error: error.message });
    }
  }

  const canSearch = material && length.trim() && width.trim() && !searchState.loading;

  return (
    <section className="odpady-page">
      <div className="odpady-page__card">
        <div className="odpady-page__header">
          <h1>Odpady</h1>
          <p>Wyszukaj elementy pasujące do podanych wymiarów</p>
        </div>

        <form className="odpady-page__form" onSubmit={handleSearch}>
          <div className="odpady-page__field">
            <label htmlFor="odpady-material">Materiał</label>
            <select
              id="odpady-material"
              value={material}
              onChange={(e) => setMaterial(e.target.value)}
            >
              {materials.map((m) => (
                <option key={m} value={m}>{m}</option>
              ))}
            </select>
          </div>

          <div className="odpady-page__field">
            <label htmlFor="odpady-length">Długość</label>
            <input
              id="odpady-length"
              type="number"
              min="0"
              step="any"
              placeholder="np. 500"
              value={length}
              onChange={(e) => setLength(e.target.value)}
              required
            />
          </div>

          <div className="odpady-page__field">
            <label htmlFor="odpady-width">Szerokość</label>
            <input
              id="odpady-width"
              type="number"
              min="0"
              step="any"
              placeholder="np. 300"
              value={width}
              onChange={(e) => setWidth(e.target.value)}
              required
            />
          </div>

          <div className="odpady-page__field">
            <label htmlFor="odpady-thickness">Grubość (opcjonalnie)</label>
            <input
              id="odpady-thickness"
              type="number"
              min="0"
              step="any"
              placeholder="np. 10"
              value={thickness}
              onChange={(e) => setThickness(e.target.value)}
            />
          </div>

          <button
            className="odpady-page__search-button"
            type="submit"
            disabled={!canSearch}
          >
            {searchState.loading ? "Szukanie..." : "Szukaj"}
          </button>
        </form>

        {searchState.error && (
          <p className="odpady-page__error">{searchState.error}</p>
        )}

        {results !== null && (
          <>
            <p className="odpady-page__count">
              Znaleziono: {results.length} {results.length === 1 ? "element" : "elementów"}
            </p>
            {results.length > 0 && (
              <div className="odpady-page__table-wrapper">
                <table className="odpady-page__table">
                  <thead>
                    <tr>
                      <th>Model</th>
                      <th>Wariant</th>
                      <th>Element</th>
                      <th>Długość</th>
                      <th>Szerokość</th>
                      <th>Grubość</th>
                      <th>Materiał</th>
                    </tr>
                  </thead>
                  <tbody>
                    {results.map((row, i) => (
                      <tr key={i}>
                        <td>{row.model}</td>
                        <td>{row.model_variant}</td>
                        <td>{row.element}</td>
                        <td>{row.length}</td>
                        <td>{row.width}</td>
                        <td>{row.thickness ?? "-"}</td>
                        <td>{row.material}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </>
        )}
      </div>
    </section>
  );
}
